import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';


@Injectable({
  providedIn: 'root'
})

export class DataMappingAdvancedSettingsCommandHandler implements IPlatformCommandHandler {
  constructor(private commandService: CommandService,
              public fuseSplashScreenService: FuseSplashScreenService,

  ) {}

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        this.fuseSplashScreenService.hide();
        return true;
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed ToolBarComponent command', error);
        return false;
      });
    return true;
  }
}

